import { Component, Host, h, Element } from '@stencil/core';

export interface AhaEventList extends HTMLAhaEventListElement {}

/**
 * A "event list" element (hence the name `<aha-event-list>`).
 *
 * Takes any number of `<aha-event-list-item>`  ("event item") elements.
 */
@Component({
  tag: 'aha-event-list',
  styleUrl: 'aha-event-list.css',
  shadow: true,
})
export class AhaEventList {
  @Element() host!: HTMLAhaEventListElement;

  render() {
    return (
      <Host role="list">
        <slot></slot>
      </Host>
    );
  }
}
